import { render } from "./BaseHistory.vue?vue&type=template&id=157841b1"
import script from "./BaseHistory.vue?vue&type=script&lang=js"
export * from "./BaseHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__